import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import nowplayerDevicesImg from '../../../images/Blog/nowplayer-devices.png';
import nowTVAppIcon from '../../../images/Blog/logo/Now-TV-app-icon.svg';
import iOSAppStoreImg from '../../../images/Blog/logo/iOS-app-store-en.svg';
import googlePlayStoreImg from '../../../images/Blog/logo/Google-Play-store-en.svg';
import appHuaweiImg from '../../../images/Blog/logo/app-huawei.svg';
import samsungTizenImg from '../../../images/Blog/logo/samsung-tizen.svg';
import LGSmartTVImg from '../../../images/Blog/logo/LG-smart-TV.png';
import androidtvtvImg from '../../../images/Blog/logo/androidtv-logo.svg';
import PanasonicFiretvImg from '../../../images/Blog/logo/Panasonic-firetv.png';

const BlogDownloadNowTV: React.FC = () => {
  const [deviceType, setDeviceType] = useState<string>('desktop');

  useEffect(() => {
    const userAgent = navigator.userAgent;

    if (/iPad|iPhone|iPod/.test(userAgent)) {
      setDeviceType('ios');
    } else if (/Android/.test(userAgent)) {
      setDeviceType('android');
    } else {
      setDeviceType('desktop');
    }
  }, []);

  return (
    <div className="download-nowtv">
      <div className="container">
        <h2>立即下載Now TV 應用程式</h2>
        <div className="nowtv-apps-wrapper">
          <div className="image"> <img src={nowplayerDevicesImg} alt="" /> </div>
          <div className="apps-wrapper">
            <div className="nowtv-app"><img src={nowTVAppIcon} alt="" /></div>
            <div className="app-labels-wrapper">
              <div className="download-section mobile">
                <h4 lang-key="onMobile">流動裝置</h4>
                {(deviceType === 'ios' || deviceType === 'desktop') && (
                  <Link
                    to="https://apps.apple.com/hk/app/now-%E9%9A%A8%E8%BA%AB%E7%9D%87/id501956183?l=en"
                    id="ios-link"
                    target="_blank"
                  >
                    <img src={iOSAppStoreImg} alt="" />
                  </Link>
                )}
                {(deviceType === 'android' || deviceType === 'desktop') && (
                  <>
                    <Link
                      to="https://play.google.com/store/apps/details?id=com.pccw.nowplayer&hl=en"
                      id="android-link"
                      target="_blank"
                    >
                      <img src={googlePlayStoreImg} alt="" />
                    </Link>
                    <Link
                      to="https://appgallery.huawei.com/app/C101453863"
                      id="huawei-link"
                      target="_blank"
                    >
                      <img src={appHuaweiImg}alt="" />
                    </Link>
                  </>
                )}
              </div>
              <div className="download-section tv">
                <h4 lang-key="onTVs">智能電視</h4>
                <img src={samsungTizenImg} alt="" className="samsung" />
                <img src={LGSmartTVImg} alt="" className="lg" />
                <img src={androidtvtvImg} alt="" className="android" />
                <img src={PanasonicFiretvImg} alt="" className="firetv" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogDownloadNowTV;